import React from 'react'
import styled from 'styled-components'
import { SCREEN_SIZE, STYLES } from '../../static/style'
import Youtube from '../../components/Youtube/Youtube'

const StyledSchoolVideos = styled.div`
  overflow-x: auto;
  margin: 0 auto;
  text-align: center;
  padding: 1rem 0;
  background-color: ${STYLES.COLOR_BLACK};
`

const VideosContainer = styled.div`
  white-space: nowrap;
  & > * {
    display: inline-block;
  }
`

const StyledYoutube = styled(Youtube)`
  width: 300px;
  height: 180px;
  margin: 0 0.5rem;
  ${SCREEN_SIZE.MD} {
    width: 300px;
    height: 180px;
  }
`

interface ISchoolVideosProps {
  youtubeVideoIds: Array<string>
}

const SchoolVideos: React.FC<ISchoolVideosProps> = ({
  youtubeVideoIds = [],
}) => (
  <StyledSchoolVideos
    onMouseDown={(ev) => ev.stopPropagation()}
    onTouchStart={(ev) => ev.stopPropagation()}
  >
    <VideosContainer>
      {youtubeVideoIds.map((videoId) => (
        <StyledYoutube key={videoId} videoId={videoId} />
      ))}
    </VideosContainer>
  </StyledSchoolVideos>
)

export { SchoolVideos }
